import { Time, parseTime } from "@internationalized/date";
import type { TimeValue } from "react-aria";

export function timeValueToString(value: TimeValue | null): string {
	if (!value) {
		return "";
	}
	const hour = String(value.hour).padStart(2, "0");
	const minute = String(value.minute).padStart(2, "0");
	return `${hour}:${minute}`;
}

export function stringToTimeValue(timeString: string): TimeValue | null {
	if (!timeString) {
		return null;
	}
	const [hour, minute] = timeString.split(":").map(Number);
	if (hour === undefined || minute === undefined) {
		return null;
	}
	return new Time(hour, minute);
}

const safeParseTime = (value: string): Time | undefined => {
	try {
		return parseTime(value);
	} catch {
		return undefined;
	}
};

export const clampTime = (field: {
	enabled: boolean;
	default?: string;
	min?: string;
	max?: string;
}): Time | undefined => {
	const minTime = field.min ? safeParseTime(field.min) : undefined;
	const maxTime = field.max ? safeParseTime(field.max) : undefined;

	if (minTime && maxTime && minTime.compare(maxTime) === 0) {
		return minTime;
	}

	if (!field.enabled || !field.default) {
		return undefined;
	}
	const defaultTime = safeParseTime(field.default);
	if (!defaultTime) {
		return undefined;
	}

	if (minTime && defaultTime.compare(minTime) < 0) {
		return minTime;
	}
	if (maxTime && defaultTime.compare(maxTime) > 0) {
		return maxTime;
	}
	return defaultTime;
};
